import APIKeyList from "@/components/Common/APIKeyList/APIKeyList.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import cloneDeep from "lodash/cloneDeep";
import EventAPIKeyEditView from "@/components/Events/EventAPIKeyEditView/EventAPIKeyEditView";
import KisApiKeyEditView from "@/components/KIS/KisApiKeyEditView/KisApiKeyEditView.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
const defaultItem = {
  apiKey: "",
  expandedPersonView: false,
  description: "",
  sortField: "lastName",
  sort: -1,
  defaultGeoLocation: {
    lng: 10.221301500000001,
    lat: 47.55488625
  },
  mailSenderName: "EO.Heimat",
  hideGeoLocationButton: false,
  defaultMapZoom: 25,
  color: {
    "color-text": "#333",
    "color-primary": "#00636C"
  },
  userPermission: "none"
};

export default {
  name: "KisAdmin",
  components: { KisApiKeyEditView, EventAPIKeyEditView, APIKeyList },
  data: () => ({
    config: { tileServer: { url: "", params: "", attribution: "" } },
    editedItem: {},
    apiKeyDialog: false
  }),
  async mounted() {
    await this.getConfig();
    await this.$store.dispatch("getAllUsers");
  },
  methods: {
    getPrincipalPaletteColors(moduleKey, widgetKey) {
      const colorPalette = this.$store.state.selectedPrincipal?.colorPalette;
      const colors = colorPalette?.[moduleKey]?.[widgetKey]?.colors;
      if (!Array.isArray(colors)) {
        return {};
      }
      return colors.reduce((acc, color) => {
        if (color?.key && color?.value) {
          acc[color.key] = color.value;
        }
        return acc;
      }, {});
    },
    getDefaultApiKeyConfig() {
      const baseConfig = cloneDeep(defaultItem);
      baseConfig.color = {
        ...defaultItem.color,
        ...this.getPrincipalPaletteColors("kis", "widget")
      };
      return baseConfig;
    },
    async getConfig() {
      try {
        const headers = getTokenHeader();
        const response = await axios.get(
          `${env.kis_api_client_url}config/${this.selectedPrincipalId}`,
          { headers }
        );
        this.config = response.data;
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError", e.toString());
      }
    },
    async editApiKey(apiKey) {
      this.editedItem = Object.assign(
        {},
        this.getDefaultApiKeyConfig(),
        cloneDeep(this.apiKeys[apiKey])
      );
      this.apiKeyDialog = true;
    },
    async removeApiKey(apiKey) {
      try {
        const isConfirmed = await this.$confirm(
          "Wollen Sie diesen API Key wirklich löschen?",
          confirmWarningConfig
        );
        if (!isConfirmed) {
          return;
        }
        const headers = getTokenHeader();
        await axios.delete(`${env.kis_api_client_url}apiKey/${apiKey._id}`, {
          headers
        });
        this.config.apiKeys = this.config.apiKeys.filter(
          key => key._id !== apiKey._id
        );
        await this.save();
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async copyApiKey(apiKey) {
      try {
        const newApiKey = cloneDeep(apiKey);
        delete newApiKey._id;
        newApiKey.apiKey = String.random();
        if (newApiKey.description) newApiKey.description += " Kopie";
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.kis_api_client_url}apiKey`,
          newApiKey,
          { headers }
        );
        if (response.status === 201) {
          this.config.apiKeys.push(response.data);
          this.config.apiKeys = this.config.apiKeys.map(key => key._id);
          await this.save();
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        } else {
          console.error(response.data, response.status);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async apiKeyPreview(apiKey) {
      if (!this.isReadOnlyApiKey) {
        const confirmRes = await this.$confirm(
          `Möchten Sie Änderungen speichern?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          await this.saveApiKey(apiKey, false);
        }
      }
      await this.showApiKey(apiKey);
    },
    async showApiKey(apiKey) {
      window
        .open(`${env.kis_widget_api_url}?apiKey=${apiKey.apiKey}`, "_blank")
        .focus();
    },
    close() {
      this.editedItem = this.getDefaultApiKeyConfig();
      this.$refs.editView?.$refs?.logOverview?.resetLogs();
      this.apiKeyDialog = false;
    },
    async addApiKey() {
      try {
        const apiKey = this.getDefaultApiKeyConfig();
        apiKey.config_ref = this.selectedPrincipalId;
        apiKey.apiKey = String.random();
        apiKey.description = "";
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.kis_api_client_url}apikey`,
          apiKey,
          { headers }
        );
        if (response.status === 201) {
          this.config.apiKeys.push(response.data);
          await this.save();
        } else {
          await this.$store.dispatch("createError");
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async saveApiKey(key, close = false) {
      if (this.isReadOnlyApiKey) {
        return;
      }
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.kis_api_client_url}apikey/${key._id}`,
          key,
          {
            headers
          }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );

          const logOverviewRef = this.$refs.editView?.$refs?.logOverview;
          const logsFetched = logOverviewRef?.logsFetched;
          logOverviewRef?.resetLogs();

          if (close) {
            this.apiKeyDialog = false;
          } else if (logsFetched) {
            await logOverviewRef?.getLogs();
          }

          await this.getConfig();
        } else {
          console.error(response.data, response.status);
          await this.$store.dispatch(
            "createError",
            "Es ist ein Fehler aufgetreten!"
          );
          await this.getConfig();
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    async updateApiKeys() {
      try {
        const headers = getTokenHeader();
        await this.apiKeys.asyncForEach(async apiKey => {
          if (this.getIsReadOnlyApiKey(apiKey)) {
            return;
          }
          await axios.put(
            `${env.kis_api_client_url}apikey/${apiKey._id}`,
            apiKey,
            { headers }
          );
        });
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
      } catch (e) {
        console.error(e);
        await this.$store.dispatch(
          "createError",
          "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut"
        );
      }
    },
    async save() {
      try {
        await this.updateApiKeys();
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.kis_api_client_url}config/${this.config._id}`,
          this.config,
          { headers }
        );
        if (response.status === 200) {
          await this.getConfig();
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        } else {
          await this.$store.dispatch("createError");
        }
      } catch (e) {
        console.error(e);
        await this.$store.dispatch("createError");
      }
    },
    getIsReadOnlyApiKey(apiKey) {
      if (this.isAdmin) {
        return false;
      }
      if (apiKey.userPermission === "edit") {
        return false;
      }
      return true;
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    selectedPrincipalId() {
      return this.$store.state.selectedPrincipal?.id;
    },
    isReadOnlyApiKey() {
      return this.getIsReadOnlyApiKey(this.editedItem);
    },
    apiKeys() {
      return this.config?.apiKeys;
    }
  },
  watch: {
    apiKeyDialog(newState) {
      if (newState) {
        const defaultApiKeyConfig = this.getDefaultApiKeyConfig();
        if (!this.editedItem.color) {
          this.editedItem.color = defaultApiKeyConfig.color;
        } else {
          for (const key of Object.keys(defaultApiKeyConfig.color)) {
            if (!this.editedItem.color[key]) {
              this.editedItem.color[key] = defaultApiKeyConfig.color[key];
            }
          }
        }
        this.$nextTick(() => this.$refs.editView?.setCodePreview());
      }
    }
  }
};
